import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { AnnotationBatchUpsert, AnnotationCreate, AnnotationDelete, AnnotationEdit, DocumentUpdate } from '../models/annotation-modification';
import { DebouncedQueuedTasksController } from '../task-run-utils/debounced-queued-tasks-controller';
import { deferred } from '@onviobr/services/utils';
import { DocumentUpdateAggregatePolicy } from './document-changes-aggregate-policy';
import { getAnnotationIdsFromXfdf } from './get-annotation-ids-from-xfdf';
export var AnnotationEditController = /*#__PURE__*/function (_ref) {
  function AnnotationEditController(document, annotationsService, documentService, serializeAnnotations, getDocumentBlob, debounceTimeoutMilliseconds, viewerStrings, onDocumentUpdateAction, handleError, initiatorId, onServerResponse, useFetchAPI) {
    var _this;
    _classCallCheck(this, AnnotationEditController);
    _this = _callSuper(this, AnnotationEditController, [new DocumentUpdateAggregatePolicy(true), debounceTimeoutMilliseconds, onServerResponse]);
    _this.document = document;
    _this.annotationsService = annotationsService;
    _this.documentService = documentService;
    _this.serializeAnnotations = serializeAnnotations;
    _this.getDocumentBlob = getDocumentBlob;
    _this.viewerStrings = viewerStrings;
    _this.onDocumentUpdateAction = onDocumentUpdateAction;
    _this.handleError = handleError;
    _this.initiatorId = initiatorId;
    _this.useFetchAPI = useFetchAPI;
    _this.noLongerDependsOnDocument = void 0;
    _this.currentDocumentLockedFlag = false;
    _this.createdAnnotations = [];
    _this.deletedAnnotations = [];
    return _this;
  }
  _inherits(AnnotationEditController, _ref);
  return _createClass(AnnotationEditController, [{
    key: "processRequest",
    value: function processRequest(request) {
      if (request) {
        this.createdAnnotations.push(request.annotationId);
      } else if (request) {
        this.deletedAnnotations.push(request.annotationId);
      }
      _superPropGet(AnnotationEditController, "processRequest", this, 3)([request]);
    }
  }, {
    key: "safeForDocumentUnload",
    value: function safeForDocumentUnload() {
      if (!this.noLongerDependsOnDocument) {
        this.noLongerDependsOnDocument = deferred();
      }
      this.flushDebouncedTasks();
      if (!this.hasUpcomingPut()) {
        var resolved = deferred();
        resolved.resolve();
        return resolved;
      }
      return this.noLongerDependsOnDocument;
    }
  }, {
    key: "refreshAnnotations",
    value: function () {
      var _refreshAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(annotationManager, xfdf) {
        var _this2 = this;
        var annotationIds, localAnnotations;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              annotationIds = getAnnotationIdsFromXfdf(xfdf);
              _context.next = 3;
              return annotationManager.importAnnotations(xfdf);
            case 3:
              localAnnotations = annotationManager.getAnnotationsList();
              localAnnotations.filter(function (a) {
                return !!a.getCustomData('contactId');
              }).forEach(function (annotation) {
                if (_this2.deletedAnnotations.includes(annotation.Id)) {
                  annotationManager.deleteAnnotation(annotation);
                }
                if (!annotationIds.includes(annotation.Id) && !_this2.createdAnnotations.includes(annotation.Id)) {
                  annotationManager.deleteAnnotation(annotation, {
                    force: true
                  });
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function refreshAnnotations(_x, _x2) {
        return _refreshAnnotations.apply(this, arguments);
      }
      return refreshAnnotations;
    }()
  }, {
    key: "performTask",
    value: function () {
      var _performTask = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(modifications) {
        var _ref2;
        var annotationsXml, createdOrUpdatedAnnotations, batchUpserted, batchUpsertedFlattened, documentModifications, exportAnnotations, parts, annotationFile, documentBlob, _document, deletedIDs, _iterator, _step, id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.currentDocumentLockedFlag = true;
              annotationsXml = '';
              createdOrUpdatedAnnotations = modifications.filter(function (modification) {
                return modification instanceof AnnotationCreate || modification instanceof AnnotationEdit;
              }).map(function (modification) {
                return modification.annotation;
              });
              batchUpserted = modifications.filter(function (modification) {
                return modification instanceof AnnotationBatchUpsert;
              }).map(function (modification) {
                return modification.annotations;
              });
              batchUpsertedFlattened = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(batchUpserted));
              createdOrUpdatedAnnotations.push.apply(createdOrUpdatedAnnotations, _toConsumableArray(batchUpsertedFlattened));
              if (!(createdOrUpdatedAnnotations.length > 0)) {
                _context2.next = 23;
                break;
              }
              _context2.prev = 7;
              _context2.next = 10;
              return this.serializeAnnotations(createdOrUpdatedAnnotations);
            case 10:
              annotationsXml = _context2.sent;
            case 11:
              _context2.prev = 11;
              this.currentDocumentLockedFlag = false;
              this.updateDocumentDependencyStatus();
              return _context2.finish(11);
            case 15:
              _context2.prev = 15;
              _context2.next = 18;
              return this.annotationsService.updateAnnotations(this.document, annotationsXml, this.initiatorId);
            case 18:
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](15);
              this.handleErrors(_context2.t0);
            case 23:
              documentModifications = modifications.filter(function (modification) {
                return modification instanceof DocumentUpdate;
              }).map(function (modification) {
                return modification;
              });
              if (!(documentModifications.length > 0)) {
                _context2.next = 52;
                break;
              }
              _context2.next = 27;
              return this.serializeAnnotations();
            case 27:
              exportAnnotations = _context2.sent;
              parts = [new Blob([exportAnnotations], {
                type: 'text/plain'
              })];
              annotationFile = new File(parts, 'metaData.xfdf');
              _context2.next = 32;
              return this.getDocumentBlob();
            case 32:
              documentBlob = _context2.sent;
              this.currentDocumentLockedFlag = false;
              this.updateDocumentDependencyStatus();
              _document = documentModifications[0];
              _context2.prev = 36;
              if (!this.useFetchAPI) {
                _context2.next = 42;
                break;
              }
              _context2.next = 40;
              return this.documentService.putUsingFetch(_document.container, _document.documentId, documentBlob, annotationFile, this.initiatorId);
            case 40:
              _context2.next = 44;
              break;
            case 42:
              _context2.next = 44;
              return this.documentService.put(_document.container, _document.documentId, documentBlob, annotationFile, this.initiatorId);
            case 44:
              this.onDocumentUpdateAction();
              _context2.next = 50;
              break;
            case 47:
              _context2.prev = 47;
              _context2.t1 = _context2["catch"](36);
              this.handleErrors(_context2.t1);
            case 50:
              _context2.next = 54;
              break;
            case 52:
              this.currentDocumentLockedFlag = false;
              this.updateDocumentDependencyStatus();
            case 54:
              this.createdAnnotations = [];
              deletedIDs = modifications.filter(function (modification) {
                return modification instanceof AnnotationDelete;
              }).map(function (modification) {
                return modification.annotationId;
              });
              _iterator = _createForOfIteratorHelper(deletedIDs);
              _context2.prev = 57;
              _iterator.s();
            case 59:
              if ((_step = _iterator.n()).done) {
                _context2.next = 71;
                break;
              }
              id = _step.value;
              _context2.prev = 61;
              _context2.next = 64;
              return this.annotationsService.deleteAnnotation(this.document, id, this.initiatorId);
            case 64:
              _context2.next = 69;
              break;
            case 66:
              _context2.prev = 66;
              _context2.t2 = _context2["catch"](61);
              this.handleErrors(_context2.t2, false);
            case 69:
              _context2.next = 59;
              break;
            case 71:
              _context2.next = 76;
              break;
            case 73:
              _context2.prev = 73;
              _context2.t3 = _context2["catch"](57);
              _iterator.e(_context2.t3);
            case 76:
              _context2.prev = 76;
              _iterator.f();
              return _context2.finish(76);
            case 79:
              this.deletedAnnotations = [];
            case 80:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[7,, 11, 15], [15, 20], [36, 47], [57, 73, 76, 79], [61, 66]]);
      }));
      function performTask(_x3) {
        return _performTask.apply(this, arguments);
      }
      return performTask;
    }()
  }, {
    key: "updateDocumentDependencyStatus",
    value: function updateDocumentDependencyStatus() {
      if (this.noLongerDependsOnDocument && !this.hasTasksInQueue()) {
        this.noLongerDependsOnDocument.resolve();
      }
    }
  }, {
    key: "hasUpcomingPut",
    value: function hasUpcomingPut() {
      return this.hasOngoingTask() && (this.currentDocumentLockedFlag || this.hasTasksInQueue());
    }
  }, {
    key: "handleErrors",
    value: function handleErrors(error) {
      var _this$document;
      var handle404 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var documentName = (_this$document = this.document) === null || _this$document === void 0 ? void 0 : _this$document.name;
      var documentNamePlaceholder = '{{document}}';
      if (error.status === 404 && handle404) {
        var _this$viewerStrings$m;
        this.handleError((_this$viewerStrings$m = this.viewerStrings.movedOrDeletedErrorMessage) === null || _this$viewerStrings$m === void 0 ? void 0 : _this$viewerStrings$m.replace(documentNamePlaceholder, documentName));
      } else if (error.status === 405) {
        var _this$viewerStrings$c;
        this.handleError((_this$viewerStrings$c = this.viewerStrings.cannotBeSavedErrorMessage) === null || _this$viewerStrings$c === void 0 ? void 0 : _this$viewerStrings$c.replace(documentNamePlaceholder, documentName));
      } else if (error.status >= 500 || error.status === 0) {
        this.handleError(this.viewerStrings.serverErrorMessage);
      }
    }
  }]);
}(DebouncedQueuedTasksController);
